import React from 'react'
import MicrositeFooter from './MicrositeFooter'

export default class CampaignFooter extends React.Component {
  render() {
    const { footerImgNorton } = this.props

    return <MicrositeFooter nortonLogo={footerImgNorton} />
  }
}
